module.exports = __webpack_public_path__ + "img/preceptory.850d4a34.png";